<template>
    <div class="view" v-if="hasPermissions(['Building-Room Read', 'Building-Room Write', 'Building-Room Room-Upload', 'Building-Room Task-Upload'])">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a <a @click="executeJob()">list</a> of all Rooms within your Facility. Click "Add Room" to create a new Room. Cllicking "Mass Delete" will delete the all Rooms within that are checked off.  Use the "Advanced Search" to add more filters to your search.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="hasPermissions(['Building-Room Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-on:input="debounceInput($event.target.value)">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                        :ref="'file_excel'"
                        :empty_format_data="empty_format_data"
                        :excel_file_headers="excel_file_headers"
                        :file_name="'rooms_template_file'"
                        @data="beforeUpload($event)"
                        v-if="hasPermissions(['Building-Room Room-Upload'])"
                    />

                <UploadOptions
                    :ref="'file_excel_tasks'"
                    :empty_format_data="empty_format_data_tasks"
                    :excel_file_headers="excel_file_headers_tasks"
                    :file_name="'room_tasks_upload_template_file'"
                    :btn_label="'Tasks Upload options'"
                    id="file_excel_input_tasks"
                    @data="upload_tasks($event)"
                    v-if="hasPermissions(['Building-Room Task-Upload'])"
                />

                    <a v-if="hasPermissions(['Building-Room Read'])" class="modal__buttons__item px-3 w-auto" href="/building-rooms-mass-edit" v-html="'Mass Edit Rooms'"/>
                    <a v-if="hasPermissions(['Building-Room Write'])" class="modal__buttons__item w-auto px-3 " v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" @click="selected ? massive_modal_delete() : null"/>

                </div>
                <div v-if="hasPermissions(['Building-Room Write'])" class="bar-container__cta">
                    <span class="float-right" style="display: inline">
                        <a href="#" @click="form_modal()" class="d-inline-md-block" style="font-size: 0.7rem !important; line-height: 0px !important; color: #404040;">
                            {{ add_btn }}
                            <i class="prefix ml-1">
                                <img src="/assets/img/svg/add.svg" alt="date" style="width: 0.8rem">
                            </i>
                        </a>
                    </span>
                </div>
        </div>


        <RoomAdvancedSearch
        class="mt-5"
        ref="advanced_search"
        :parent_rooms="rooms"
        :parent_pagination="pagination"
        :use_parent="true"
        :table_headers="table_headers"
        :checkeable="true"
        :historiable="true"
        :updateable="true"
        :rest_api="'rooms'"
        :rest_api_pagination="'rooms_pagination'"
        :parent_totals="totals"
        :detail_text="'Quick view'"
        @passInitialData="getInitialData($event)"
        @modal_update="modal_update($event)"
        @history="history($event)"
        @paginateMoreRecordsParent="paginateMoreRecords($event)"
        @fetchMainListParent="fetchMainList($event)"
        :search="search"
        />
                       
        <DeletionModal
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal
            ref="form_modal"
            :title="'New Room'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :bed_numbers="bed_numbers"
            :array_options="array_options"
            :next_walking_number="next_walking_number"
            :from_child="false"
            :save_view="true"
            @unshiftObject="unshift_object($event)"
            @saveView="save_and_view($event)"
        />

        <UpdateModal
            ref="UpdateModal"
            :title="'Room Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :single_object="single_object"
            :single_object_backup="single_object_backup"
            :global_index="global_index"
            :bed_numbers="bed_numbers"
            :array_options="array_options"
            :is_description_dynamic="single_object.default_description"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <HistoryModal
            :histories="histories"
            :title="history_title"
            :breadcrumb="breadcrumb"
            :change_type="true"
            :link_event="true"
            :link_message="`<a href='#'>View Tasks movement history</a>`"
            @linkEventReceiver="linkEmitReceptor()"
        />

        <HistoryMovementModal
            :notyf="notyf"
            :link_message="`<a href='#'>Back to History</a>`"
            :rest_api="rest_api"
            :history_item="history_item"
            :breadcrumb="breadcrumb"
            :link_event="true"
            @linkEventReceiver="linkEmitEmisor()"
        />

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="name_file_summary"
        />
        <ConfirmationModalDefaultTasks 
        :breadcrumb="breadcrumb"
        :title="'Confirmation of Default Tasks'"
        @upload="upload($event)"
        />
        <HelperModal :helps="helps"/>

    </div>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import FormResources        from    './form_resources'
import Resources            from    './resources'
import HelperModal          from    '@/components/HelperModal'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import ConfirmationModalDefaultTasks  from    './ConfirmationModalDefaultTasks'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import RoomAdvancedSearch   from    './AdvancedSearch/RoomAdvancedSearch'
import LocalHelper          from    './LocalHelper'
import HistoryModal         from    '@/components/HistoryModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import HistoryMovementModal from    '@/components/DetailComponent/HistoryMovementModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'


import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import _ from 'lodash'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'Room',

    components: {
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DeletionModal,
        DeletionMassiveModal,
        RoomAdvancedSearch,
        HistoryModal,
        UploadOptions,
        UploadSummary,
        HistoryMovementModal,
        UnauthorizedComponent,
        ConfirmationModalDefaultTasks,
        HelperModal
    },

    mixins: [
        LocalHelper,
    ],

    data() {
        return {
            notyf,
            child_href:                     '/building-room/',
            title_page:                     'Rooms',
            rest_api:                       `rooms`,
            rest_api_pagination:            `rooms_pagination`,
            single_select:                  false,
            table_selection:                [],
            table_headers:                  Resources.table_headers,
            breadcrumb:                     Resources.breadcrumb,
            field:                          FormResources.fields,
            boolean_options:                FormResources.boolean_options,
            status_options:                 FormResources.status_options,
            exc_options:                    FormResources.exc_options,
            simbol_options:                 FormResources.simbol_options,
            excel_file_headers:             Resources.excel_file_headers,
            empty_format_data:              Resources.empty_format_data,
            excel_fields_required:          Resources.excel_fields_required,
            excel_file_headers_tasks:       Resources.excel_file_headers_tasks,
            empty_format_data_tasks:        Resources.empty_format_data_tasks,
            excel_fields_required_tasks:    Resources.excel_fields_required_tasks,
            add_btn:                        'Add Room',
            search:                         '',
            global_index:                   null,
            single_object:                  {},
            single_object_backup:           {},
            tasks:                          [],
            bed_numbers:                    {},
            array_options:                  {},
            display_table:                  true,
            next_walking_number:            0,
            histories:                      [],
            history_title:                  '',
            select_ids:                     [],
            save_view:                      false,
            summary:                        [],
            excel_data:                     [],
            name_file_summary:              '',
            history_item:                   {},
            upload_data:                    [],
            pagination: null,
            rooms: [],
            array_options_table: [],
            totals: [],
            helps:  Resources.helps
        }
    },

    methods:{
        async executeJob()
        {
            await this.get(`${this.rest_api}/job/beds`)
        },
        
        async unshift_object(new_object)
        {
            if(this.save_view)
            {
                window.location.href = `${this.child_href}${new_object.id}`
            }
            this.rooms.push(new_object)
            this.totals[0].sq_ft.value = (Number(this.totals[0].sq_ft.value.replace(/,/g, '')) + this.stringToNumber(new_object.sq_ft)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },

        splice_object(splicing_object)
        {
            this.totals[0].sq_ft.value = (Number(this.totals[0].sq_ft.value.replace(/,/g, '')) - this.stringToNumber(this.rooms[splicing_object.index].sq_ft)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            this.totals[0].sq_ft.value = (Number(this.totals[0].sq_ft.value.replace(/,/g, '')) + this.stringToNumber(splicing_object.single_object.sq_ft)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            const minutes = this.rooms[splicing_object.index].daily_minutes

            this.rooms.splice(splicing_object.index, 1, {...splicing_object.single_object})

            this.rooms[splicing_object.index].daily_minutes = minutes
            
            // console.log(splicing_object)
            // this.$refs.advanced_search.resetList()
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.rooms[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object_backup = {...this.rooms[index]}
            this.single_object = {...this.rooms[index]}
            this.$refs.UpdateModal.setChild(this.single_object.child, this.single_object.parent_description)
            window.$('#static-update').modal('show')
        },

        getInitialData(data)
        {
            this.bed_numbers = data.bed_numbers
            this.tasks = data.tasks
            
            this.array_options = {
                room_type_id: data.room_types,
                cost_center_id: data.cost_centers,
                floor_id: data.floors,
                level_id: [],
                area_id: data.areas,
                daily_task_id: data.daily_tasks
            }


            this.next_walking_number = data.next_walking_number

            
        },


        trashing(index)
        {
            this.rooms.splice(index, 1)
        },

        change_display_table()
        {
            this.display_table = !this.display_table;
        },

        async history(id, title)
        {
            if(title === undefined)
            {
                title = id.title
                id = id.id
            }

            const http_request = {
                id,
                history_request: true,
            }

            this.history_item = {
                id,
                title,
            }

            this.loader(true)
            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
            this.loader()

            if (response.status)
            {
                this.history_title = title
                this.histories = response.data.histories

                this.histories.forEach(history => {
                    history.fields = history.fields.filter(field => field.key != 'time_adjustment')
                })
                this.histories = this.histories.filter(history => !(history.fields.length === 0 && history.action === "Updating") )

                if(this.histories.length === 0)
                {
                    return this.notyf.error('Empty History')
                }
                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }
            
        },

        massive_modal_delete()
        {
            let selection = this.$refs.advanced_search.returnedRoomsToParent()

            selection.checked_items = selection.checked_items.map(item => item.id)
            selection.unchecked_items = selection.unchecked_items.map(item => item.uncrypted_id)

            this.select_ids = selection

            if(this.select_ids.checked_items.length )
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive = await this.massive_delete(this.select_ids)

            if(sendingMassive)
            {
                this.select_ids.checked_items.forEach( item =>
                {
                    const index = this.rooms.findIndex(value => value.id == item)

                    if(index > -1)
                    {
                        this.totals[0].sq_ft.value = (Number(this.totals[0].sq_ft.value.replace(/,/g, '')) - this.stringToNumber(this.rooms[index].sq_ft)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        this.rooms.splice(index, 1)
                    }
                })

                this.$refs.advanced_search.resetSelectAll()
                this.select_ids = []
            }
        },

        save_and_view(event)
        {
            this.save_view = event
        },

        async beforeUpload(data)
        {
            this.upload_data = data;
            window.$('#static-confirmation-default-tasks').modal('show')

        },

        async upload(params)
        {
            this.name_file_summary = 'rooms_failed_template_file'

            let data = this.upload_data
            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { rooms: this.excel_data, params, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }
                this.excel_file_headers = Resources.excel_file_headers
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                this.$refs.advanced_search.resetList()
            }
            else
            {
                this.error_handling(response)
            }
                

            this.$refs.file_excel.clear_data()
        },

        async upload_tasks(data)
        {
            this.name_file_summary = 'tasks_failed_template_file'

            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive_tasks`, { room_tasks: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.excel_file_headers = Resources.excel_file_headers_tasks
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                this.$refs.advanced_search.resetList()
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel_tasks.clear_data()
        },

        linkEmitReceptor()
        {
            window.$('#static-history').modal('hide')

            setTimeout(() => {
                window.$('#static-history-movement').modal('show')
            }, 500)
        },

        linkEmitEmisor()
        {
            window.$('#static-history-movement').modal('hide')

            setTimeout(() => {
                window.$('#static-history').modal('show')
            }, 500)
        },

        async paginateMoreRecords(params)
        {
            if(this.rooms.length >= this.pagination?.total)
            {
                return;
            }
            this.$refs.advanced_search.showLoader()

            await this.apiRequest(params)
        },

        async fetchMainList(params) 
        {
            this.rooms = [];
            this.$refs.advanced_search.showLoader()
            await this.apiRequest(params, true)
        },


        async loadMoreRecords(data, reset_list)
        {
            this.pagination = data.pagination

            if(reset_list)
            {
                this.rooms = []
            }
            if(this.pagination.data.length)
            {
                this.pagination.data.forEach((item) => {
                    item.checked = this.$refs.advanced_search.isSelectAll()
                    // const new_item = {
                    //     ...item,
                    //     description: item.sort_desc
                    // }
                    this.rooms.push(item)
                })
            }
            
            this.totals = []

            const total_sq = { 'sq_ft':
                {
                    'type': '',
                    'text': 'Sq. Feet',
                    'value': data.sq_ft,
                    'show' : true,
                },
            }

            this.totals.push(total_sq)

            this.$refs.advanced_search.hideLoader(this.pagination.data)
        },

        debounceInput:  _.debounce(function (e)  {
            this.search = e
        },800),

    },

    async mounted()
    {
        if(!this.hasPermissions(['Building-Room Read', 'Building-Room Write', 'Building-Room Room-Upload']))
        {
            window.location.href = '/'
            return;
        }

    },

    computed:
    {
        selected()
        {
            const bool = this.rooms.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>